module.exports = __webpack_public_path__ + "img/chat-inbound-new.528f24d7.svg";